<aside id="sidebar">
    <div class="sidenav-outer">
        <div class="side-menu">
            <div class="menu-body">
                <ul class="nav nav-pills nav-stacked sidenav">
                    <li *ngFor="let menuItem of menuItems">
                        <a [routerLink]="menuItem.route">
                            <i class="fa {{menuItem.icon}}"></i>
                        </a>
                        <ul class="nested-dropdown animated">
                            <li *ngIf="menuItem.title" class="sidemenu-header">{{menuItem.title}}</li>
                            <li *ngFor="let menuRow of menuItem.children"><a [routerLink]="menuRow.route">{{menuRow.name}}</a></li>
                        </ul>
                    </li>
                    <!--<li [routerLinkActive]="['active']">
        <a [routerLink]="['home']">
            <i class="fa fa-home"></i>
        </a>
        <ul class="nested-dropdown animated">
            <li><a [routerLink]="['home']">Dashboard</a></li>
        </ul>
    </li>
    <li [routerLinkActive]="['active']">
        <a [routerLink]="'customer/list'">
            <i class="fa fa-users"></i>
        </a>
        <ul class="nested-dropdown animated">
            <li class="sidemenu-header">Clienti</li>
            <li><a [routerLink]="'customer/list'">Lista clienti</a></li>
            <li><a [routerLink]="'customer/detail'">Nuovo cliente</a></li>
        </ul>
    </li>
    <li [routerLinkActive]="['active']">
        <a [routerLink]="'destination/list'">
            <i class="fa fa-map-marker"></i>
        </a>
        <ul class="nested-dropdown animated">
            <li class="sidemenu-header">Destinazioni</li>
            <li><a [routerLink]="'destination/list'">Lista destinazioni</a></li>
            <li><a [routerLink]="'destination/detail'">Nuova destinazione</a></li>
        </ul>
    </li>
    <li [routerLinkActive]="['active']">
        <a [routerLink]="'article/list'">
            <i class="fa fa-th-large"></i>
        </a>
        <ul class="nested-dropdown animated">
            <li class="sidemenu-header">Articoli</li>
            <li><a [routerLink]="'article/list'">Lista articoli</a></li>
            <li><a [routerLink]="'article/detail'">Nuovo articolo</a></li>
        </ul>
    </li>
    <li [routerLinkActive]="['active']">
        <a [routerLink]="'stockmovement/list'">
            <i class="fa fa-cubes"></i>
        </a>
        <ul class="nested-dropdown animated">
            <li class="sidemenu-header">Movimenti magazzino</li>
            <li><a [routerLink]="'stockmovement/list'">Lista movimenti</a></li>
            <li><a [routerLink]="'stockmovement/detail'">Nuovo movimento</a></li>
        </ul>
    </li>
    <li [routerLinkActive]="['active']">
        <a [routerLink]="'doc/list'">
            <i class="fa fa-file"></i>
        </a>
        <ul class="nested-dropdown animated">
            <li class="sidemenu-header">Noleggi</li>
            <li><a [routerLink]="'doc/list'">Lista noleggi</a></li>
            <li><a [routerLink]="'doc/detail'">Nuovo noleggio</a></li>
        </ul>
    </li>
    <li [routerLinkActive]="['active']">
        <a [routerLink]="'calendar/list'">
            <i class="fa fa-calendar"></i>
        </a>
        <ul class="nested-dropdown animated">
            <li class="sidemenu-header">Calendario</li>
            <li><a [routerLink]="'calendar/list'">Lista articoli</a></li>
        </ul>
    </li>-->
                </ul>
            </div>
        </div>
        <div class="side-widgets">
            <div class="widgets-content">
                <div class="profile text-center"> 
                    <img src="assets/images/globus.svg" class="user-avatar" />
                </div>
                <div class="calendar-container text-center">
                    <my-calendar></my-calendar>
                </div>
                <div class="news-feed">
                    <div class="feed-header">NEWS</div>
                    <div class="feed-content">
                    </div>
                </div>
            </div>
        </div>
    </div>
</aside>